<template>
<b-container class="bv-example-row">
    <Header></Header>
    <b-row>
      <b-col cols="12" class="hr"></b-col>
    </b-row>
    <b-row>
        <b-col cols="3">
          <Menu></Menu>
        </b-col>
        <b-col cols="9" class="border">
          <b-row>
            <b-col cols="12">
              <b-row>
                <b-col cols="12">
                  <b-row>
                    <b-col cols="12" class="head">
                      <h4>:: Oficinas</h4>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" class="breadcrumb">
                      <b-link :to="{ name: 'SupervisorOffices' }">Oficinas</b-link> &raquo; Editar:
                    </b-col>
                  </b-row>
                  <div class="mt-2"></div>
                  <b-form @submit="onSubmit" class="pb-4">
                    <b-form-group id="f_name"
                              horizontal
                              :label-cols="4"
                              breakpoint="md"
                              label="Nombre">
                      <b-form-input id="name" :state="state" v-model.trim="office.name"></b-form-input>
                    </b-form-group>
                    <b-form-group id="f_address"
                              horizontal
                              :label-cols="4"
                              breakpoint="md"
                              label="Dirección">
                      <b-form-input id="address" :state="state" v-model.trim="office.address"></b-form-input>
                    </b-form-group>
                    <b-form-group id="f_phone"
                              horizontal
                              :label-cols="4"
                              breakpoint="md"
                              label="Teléfono">
                      <b-form-input id="phone" :state="state" v-model.trim="office.phone"></b-form-input>
                    </b-form-group>
                    <b-form-group id="f_department"
                              horizontal
                              :label-cols="4"
                              breakpoint="md"
                              label="Departamento">
                      <b-form-input id="department" :state="state" v-model.trim="office.department"></b-form-input>
                    </b-form-group>
                    <b-form-group id="f_district"
                              horizontal
                              :label-cols="4"
                              breakpoint="md"
                              label="Distrito">
                      <b-form-input id="district" :state="state" v-model.trim="office.district"></b-form-input>
                    </b-form-group>

                    <b-form-group id="f_status"
                              horizontal
                              :label-cols="4"
                              breakpoint="md"
                              label="Código SAP">
                      <b-form-input id="status" :state="state" v-model.trim="office.codigo_sap"></b-form-input>
                    </b-form-group>
                    <!-- <b-form-group id="f_brands"
                              horizontal
                              :label-cols="4"
                              breakpoint="md"
                              label="Marcas">
                      <b-form-input id="brands" :state="state" v-model.trim="brands"></b-form-input>
                    </b-form-group> -->
                    <b-form-group id="fieldsetHorizontal4"
                              horizontal
                              :label-cols="12"
                              breakpoint="md"
                              label="Seleccionar Marca(s)">
                      <!--div class="form-group" :class="{'has-error': errors.has('brand') }" >
                        <b-form-select id="brand" :state="state" v-model.trim="register.brand" v-validate="'required'" name="brand" :options="brands"></b-form-select>
                        <span v-show="errors.has('brand')" class="help is-danger">Seleccione una marca</span>
                      </div-->
                      <!-- Checkboxes -->
                      <div class="form-group container" :class="{'has-error': errors.has('brand') }" >
                        <div class="row">
                          <div class="col-sm-6 check-box-marca" v-for="brand in brands" :key="brand.value">
                            <b-form-checkbox :id="brand.text" :value="brand.value" name="brand" v-model="items.checks" >
                            </b-form-checkbox>
                            <label for="brands">{{ brand.value }} </label>
                          </div>
                        </div>
                      </div>
                      <div v-for="(error, index) of errors" :key="index">
                        <b-alert show>{{error.message}}</b-alert>
                      </div>
                    </b-form-group>
                    <b-button type="submit" variant="primary derco">Actualizar</b-button>
                  </b-form>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
    </b-row>
  </b-container>
</template>

<script>
/*eslint-disable */
import axios from 'axios'
import Header from './Header'
import Menu from './Menu'
export default {
  name: 'EditOffice',
  components:{
    Header,
    Menu
  },
  data () {
    return {
      office: [],
      brands: [], // para los checbocks
      oldBrands: [],  //  brands que actualmente tiene 
      arrayBrands: [],  //  brands totales
      items: {
        checks:[

        ]
      }
    }
  },
  created () {
    if(localStorage.getItem('role')=="Administrador"){
      document.title = 'Administración Derco - Editar Marca'
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios
        .get(`/brand`)
        .then(response => {
          for(var i=0; i<response.data.length; i++){
            var item = { value: response.data[i].name, text: response.data[i].name }
            this.brands.push(item)
            this.arrayBrands.push(response.data[i])
          }
        })
        .catch(e => {
          this.errors.push(e);
          if (e.response.status === 401) {
            this.$router.push({
              name: "Login"
            })
          }
        });
      axios.get(`/office/` + this.$route.params.id)
      .then(response => {
        this.office = response.data
        this.oldBrands = response.data.brands
        this.items.checks = this.office.brands.map(brand => brand.name);
        /* 
        this.office.brands.forEach(brand => {
          this.brands = this.brands + (this.brands == '' ?  `${brand.name}` : `,${brand.name}`)
        }) */
      })
      .catch(e => {
        this.errors.push(e)
      })
    }else{
      this.$router.push({
        name: 'Login'
      })
    }
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault()
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      let brands_selected = this.items.checks.toString();
      let brandPost = brands_selected.split(',');
      let flat = false;
      this.office.brands = [];
      brandPost.forEach(e => {
        let newBrand = this.arrayBrands.find(b => b.name == e)
        if (newBrand){
          flat = true;
          this.office.brands.push({name: newBrand.name, slug: newBrand.slug});
        }
      })
      if (!flat){
        this.office.brands = this.oldBrands;
      }
      axios.put(`/office/` + this.$route.params.id, this.office)
      .then(response => {
        this.$router.push({
          name: 'ShowOffice',
          params: { id: this.$route.params.id }
        })
      })
      .catch(e => {
        this.errors.push(e)
      })
    }
  }
}
</script>
<style>
.form-row legend{
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/EditOffice.vue